/**
 * LOP data for metabase reporting
 * @param {Record<string, any> | null | undefined} sessionCache
 * @returns {string}
 */
export function getAbTestPayloadString(sessionCache) {
  const lop = {
    flow_experiment_id: sessionCache?.flow_experiment_id || '',
    flow: sessionCache?.flow || '',
    flow_id: sessionCache?.flow_id || '',
  }

  if (!lop.flow_experiment_id && !lop.flow && !lop.flow_id) return ''

  return JSON.stringify(lop)
}
